import React, {useState} from "react";

//Import Assets
import "./BlogCard.scss";
import {generateFileMediaUrl} from "../../../../utils/generateMediaUrl";
import moment from "moment";
import {NewsArrIcon, VideoStartIcon} from "../../../../assets/images";
import VideoModal from "../../modal/VideoModal/VideoModal";
import {Link} from "react-router-dom";
import {BLOGS_TYPE} from "../../../../constants/constType";
import Badge from "../../badge/Badge";

function BlogCard(props){
    const {item} = props
    const [videoModalOpen,setVideoModalOpen] = useState(false)

    function toggleVideoModalOpen(){
        setVideoModalOpen(!videoModalOpen)
    }

    return item?.type !== BLOGS_TYPE.video ? <Link to={`/news/${item?.slug}`} className={`blog-block`}>
                <div className={'blog-block-img'}>
                    <div className={'blog-block-type'}>
                        {item?.type ? <Badge type={item?.type}/> : ''}
                    </div>
                    {
                        item?.mediaMain?.coverPath || item?.mediaMain?.path ?  <img src={generateFileMediaUrl(item?.mediaMain?.coverPath || item?.mediaMain?.path)}/> :
                        <div className={'bg_card_grey'}/>
                    }
                </div>
        <div className={'blog-block-info'}>
            <div className={'blog-date'}>
                {moment(item?.date).format('ll')}
            </div>
            <div className={'blog-title-wrapper'}>
                <div className={'blog-block-title'}>
                    {item?.title}
                </div>
                <Link to={`/news/${item?.slug}`} className={'blog-block-link'}>
                    <NewsArrIcon/>
                </Link>
            </div>
            {
                item?.subTitle && <div className={'blog-block-description'}
                    // dangerouslySetInnerHTML={{__html: item?.description}}
                >
                    {item?.subTitle}
                </div>
            }
        </div>
        <VideoModal item={item}
                    visible={videoModalOpen}
                    closeModal={toggleVideoModalOpen}/>
    </Link> :
        <div className={`video-block`}>
        {
            item?.type === BLOGS_TYPE.video && (item?.youtubeLink || item?.video?.path) ? <div className={'blog-block-img'}>
                    <div className={'blog-block-type'}>
                        {item?.type ? <Badge type={item?.type}/> : ''}
                    </div>
                    <div className={'blog-video-start'} onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault();
                        toggleVideoModalOpen()
                    }}>
                        <VideoStartIcon/>
                    </div>
                <Link to={`/news/${item?.slug}`}>
                    {
                        item?.mediaMain?.coverPath || item?.mediaMain?.path ?  <img src={generateFileMediaUrl(item?.mediaMain?.coverPath || item?.mediaMain?.path)}/> :
                            <div className={'bg_card_grey'}/>
                    }
                </Link>
                </div> :
                <Link to={`/news/${item?.slug}`} className={'blog-block-img'}>
                    <div className={'blog-block-type'}>
                        {item?.type ? <Badge type={item?.type}/> : ''}
                    </div>
                    {
                        item?.mediaMain?.coverPath || item?.mediaMain?.path ?  <img src={generateFileMediaUrl(item?.mediaMain?.coverPath || item?.mediaMain?.path)}/> :
                            <div className={'bg_card_grey'}/>
                    }
                </Link>
        }
        <Link to={`/news/${item?.slug}`} className={'blog-block-info'}>
            <div className={'blog-date'}>
                {moment(item?.date).format('ll')}
            </div>
            <div className={'blog-title-wrapper'}>
                <div className={'blog-block-title'}>
                    {item?.title}
                </div>
                <Link to={`/news/${item?.slug}`} className={'blog-block-link'}>
                    <NewsArrIcon/>
                </Link>
            </div>
            {
                item?.subTitle && <div className={'blog-block-description'}
                    // dangerouslySetInnerHTML={{__html: item?.description}}
                >{
                    item?.subTitle
                }
                </div>
            }
        </Link>
        <VideoModal item={item}
                    visible={videoModalOpen}
                    closeModal={toggleVideoModalOpen}/>
    </div>
}
export default BlogCard
